import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Formsy from 'formsy-react';
import { t } from 'i18next';
import React from 'react';

import MinimalTextBox from '@sophocles/components/FormFields/MinimalTextBox';

class IssueCategoryDialog extends React.Component {
  constructor(props) {
    super(props);
    const { category, categories, nameError } = props;
    this.state = {
      obsolete: category ? category.get('obsolete', false) : false,
      canSubmit: true,
      eligible_for_rma: category ? category.get('eligible_for_rma', false) : false,
    };
  }

  _toggleObsolete = () => this.setState({ obsolete: !this.state.obsolete });

  _toggleRma = () => this.setState({ eligible_for_rma: !this.state.eligible_for_rma });

  handleClose = () => this.props.closeDialog();

  save = values => {
    const { save, category } = this.props;
    const id = category ? category.get('id', 0) : 0;
    values.obsolete = this.state.obsolete;
    values.eligible_for_rma = this.state.eligible_for_rma;
    return save(id, values);
  };

  submitForm = () => this.form.submit();

  enableSaveButton = () => this.setState({ canSubmit: true });

  disableSaveButton = () => this.setState({ canSubmit: false });

  updateCategory = event => this.setState({ category: event.target.value });

  render() {
    const { open, category, categories, edit, errors, nameError, clearErrors } = this.props;
    const { canSubmit, obsolete, eligible_for_rma, name } = this.state;

    const actions = [
      <Button key="cancel" variant="outlined" onClick={this.handleClose}>
        {t('actions.cancel', 'Cancel')}
      </Button>,
      <Button key="submit" variant="contained" disabled={!canSubmit} onClick={this.submitForm}>
        {t('actions.submit', 'Submit')}
      </Button>,
    ];

    const dialogTitle = (edit ? 'Edit' : 'Add') + ' Category';

    return (
      <Dialog open={open} onClose={this.handleClose}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent dividers>
          <Formsy
            ref={input => (this.form = input)}
            onSubmit={this.save}
            onValid={this.enableSaveButton}
            onInvalid={this.disableSaveButton}
          >
            <div style={{ fontSize: '14px' }}>
              <div>
                <label style={{ margin: 0 }}>
                  <input type="checkbox" checked={obsolete} onChange={this._toggleObsolete} /> Hidden
                </label>
              </div>
              <div style={{ padding: '0 0 8px 8px', fontSize: '.8rem' }}>
                Marking a category hidden will prevent it from being visible to the support staff for future use. In
                addition, all related issues will be marked hidden.
              </div>
              <div>
                <label style={{ margin: 0 }}>
                  <input type="checkbox" checked={eligible_for_rma} onChange={this._toggleRma} /> RMA Category
                </label>
              </div>
              <div style={{ padding: '0 0 8px 8px', fontSize: '.8rem' }}>
                This category will appear as a choice for support staff when filling out an RMA.
              </div>
              <div>
                <label style={{ margin: 0, fontWeight: 'bold' }}>Name</label>
                <MinimalTextBox
                  required
                  name="name"
                  value={category ? category.get('name', '') : ''}
                  inputProps={{ rows: 1, maxLength: 50 }}
                  maxLength="50"
                />
              </div>
              <div style={{ color: 'red' }}>{nameError}</div>
            </div>
          </Formsy>
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

export default IssueCategoryDialog;
